//====== WR data 15/09/2026 — SmartFlow Item Importer (Fase 3)
// Motivo da alteração: tela "Itens Importados" — mesmo padrão de SmartFlowParceirosImportados.js
// (Parceiro), bem mais enxuta: sem endereço/fiscal, os campos são os de um Material (Item) do SAP.
// Acessada POR PROJETO, na sidebar logo abaixo de "Parceiros de Negócio Importados".
//
// Rota: /admin/smartFlowItensImportados/:parentId (parentId = id do SmartFlowProject).
//======
import React from "react"
import ReactBSAlert from "react-bootstrap-sweetalert"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Table,
  Input,
  Button,
  Badge,
  Modal,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap"

import { utils, writeFile } from "xlsx"

import SimpleHeader from "components/Headers/SimpleHeader.js"
import Loading from "components/Modals/Loading"
import api from "services/api"
import apiSap from "services/sapApi"
import { listarItensStaging, excluirItemStaging } from "services/smartflow/itemImporterApi"
import { excluirItemDoSap } from "services/smartflow/itemSapWrite"
import { formatQuantidade, formatValorItem } from "components/SmartFlow/itemImporterLogic"

const USEREMAIL_KEY = "smartflow_user_email"

//====== WR data 16/09/2026 — pedido do usuário: mostrar também na tela de detalhe os campos
// fiscais/inventário extras (mesmos rótulos da grade de Revisão e Gravação SAP).
const MATERIAL_TYPE_LABELS = {
  mt_GoodsForReseller: "Mercadoria para Revenda",
  mt_RawMaterial: "Matéria-prima",
  mt_Package: "Embalagem",
  mt_GoodsInProcess: "Mercadorias em processo",
  mt_FinishedGoods: "Produtos acabados",
  mt_SubProduct: "Subproduto",
  mt_IntermediateMaterial: "Produto Intermediário",
  mt_ConsumerMaterial: "Material de Uso e Consumo",
  mt_FixedAsset: "Ativo Imobilizado",
  mt_Service: "Serviços",
  mt_OtherInput: "Outros insumos",
  mt_Other: "Outras",
}
const ADMINISTRAR_POR_LABELS = { nenhum: "Nenhum", serie: "Nº de série", lote: "Lote" }

function formatarData(valor) {
  if (!valor) return "—"
  try {
    return new Date(valor).toLocaleString("pt-BR")
  } catch (error) {
    return "—"
  }
}

// WR data 16/09/2026 — pedido do usuário: mostrar Sim/Não em vez do valor cru do SAP (tYES/tNO).
function simNao(valor) {
  return valor === "tYES" ? "Sim" : "Não"
}

class SmartFlowItemsImportados extends React.Component {
  state = {
    loading: true,
    project: null,
    alert: null,

    termo: "",
    page: 1,
    itens: [],
    total: 0,
    pageSize: 20,
    listLoading: false,
    listError: null,
    excluindoId: null,
    exportando: false,

    detalhe: null,
  }

  _debounce = null

  componentDidMount() {
    this.loadProject(this.props.match.params.parentId)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.parentId !== this.state.project?._id) {
      this.loadProject(nextProps.match.params.parentId)
    }
  }

  loadProject = async (id) => {
    this.setState({ loading: true })
    try {
      const { data: project } = await api.get("/smartflowproject/read/" + id)
      if (project.serviceLayerUrl) {
        try {
          document.cookie = "B1SESSION=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
          const loginResp = await apiSap.post(project.serviceLayerUrl + "/Login", {
            CompanyDB: project.serviceLayerDataBase,
            UserName: project.serviceLayerUser,
            Password: project.serviceLayerPassword,
          })
          localStorage.setItem("sl_session_id", loginResp.data.SessionId)
        } catch (error) {
          localStorage.removeItem("sl_session_id")
          this.notify(
            "Não foi possível logar na Service Layer do projeto. A exclusão no SAP pode falhar.",
            "warning"
          )
        }
      }
      this.setState({ project, loading: false }, this.fetchLista)
    } catch (error) {
      this.notify("Não foi possível carregar o projeto.", "danger")
      this.setState({ loading: false })
    }
  }

  fetchLista = async () => {
    const { project, termo, page } = this.state
    if (!project) return
    this.setState({ listLoading: true, listError: null })
    try {
      const { itens, total, pageSize } = await listarItensStaging({
        projectId: project._id,
        termo,
        page,
      })
      this.setState({ itens, total, pageSize: pageSize || 20, listLoading: false })
    } catch (error) {
      this.setState({
        listLoading: false,
        listError: error?.response?.data?.error || error?.message || "Falha ao carregar a lista.",
      })
    }
  }

  //====== WR data 16/09/2026 — pedido do usuário: exportar Excel também nesta tela de consulta
  // (já existia só na grade de "Revisão e Gravação SAP", antes de gravar). Busca TODAS as páginas
  // que batem com o filtro atual (não só a página visível) antes de gerar a planilha.
  handleExportarExcel = async () => {
    const { project, termo } = this.state
    if (!project) return
    this.setState({ exportando: true })
    try {
      const todos = []
      let page = 1
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const { itens, total, pageSize } = await listarItensStaging({ projectId: project._id, termo, page })
        todos.push(...itens)
        if (todos.length >= total || !itens.length) break
        page += 1
        void pageSize
      }
      if (!todos.length) {
        this.notify("Nenhum item pra exportar.", "warning")
        return
      }
      const linhas = todos.map((it) => ({
        ItemCode: it.itemCode,
        ItemName: it.itemName,
        "Grupo (code)": it.itemsGroupCode,
        Unidade: it.inventoryUOM,
        Estoque: simNao(it.inventoryItem),
        Venda: simNao(it.salesItem),
        Compra: simNao(it.purchaseItem),
        "Código de barras (EAN)": it.cEAN,
        NCM: it.ncm,
        CEST: it.cestCode,
        "Código do fornecedor (cProd)": it.cProd,
        Situação: it.valid === "tYES" ? "Ativo" : "Inativo",
        Status: it.status === "gravado_sap" ? "Gravado no SAP" : "Simulado",
        "Nota de origem": [it.origemNumeroNf, it.origemArquivoNome].filter(Boolean).join(" — "),
        "Preparado por": it.preparadoPor,
        "Preparado em": formatarData(it.preparadoEm),
      }))
      const planilha = utils.json_to_sheet(linhas)
      const livro = utils.book_new()
      utils.book_append_sheet(livro, planilha, "Itens Importados")
      writeFile(livro, `smartflow-itens-importados-${project._id}.xlsx`)
    } catch (error) {
      this.notify(error?.response?.data?.error || error?.message || "Falha ao exportar.", "danger")
    } finally {
      this.setState({ exportando: false })
    }
  }

  onTermoChange = (e) => {
    const termo = e.target.value
    this.setState({ termo, page: 1 })
    clearTimeout(this._debounce)
    this._debounce = setTimeout(this.fetchLista, 400)
  }

  goToPage = (page) => this.setState({ page }, this.fetchLista)

  handleExcluir = async (item) => {
    // eslint-disable-next-line no-alert
    const ok = window.confirm(
      `Excluir o item "${item.itemName || item.itemCode}"? Remove do SAP (se existir) e do banco. ` +
        `Esta ação não pode ser desfeita.`
    )
    if (!ok) return

    // Exclusões independentes — mesmo motivo do lado de Parceiro (cold start do Render podia
    // deixar a operação pela metade).
    const slUrl = this.state.project?.serviceLayerUrl
    this.setState({ excluindoId: item._id })
    const falhas = []
    try {
      if (slUrl) await excluirItemDoSap(item.itemCode, slUrl)
    } catch (error) {
      falhas.push(`SAP: ${error?.message || "falha"}`)
    }
    try {
      await excluirItemStaging(item, localStorage.getItem(USEREMAIL_KEY) || null)
    } catch (error) {
      falhas.push(`banco interno: ${error?.message || "falha"}`)
    }

    this.setState({ excluindoId: null })
    if (falhas.length === 0) {
      this.notify("Item excluído com sucesso (SAP + banco interno).", "success")
      this.setState({ detalhe: null }, this.fetchLista)
    } else {
      this.notify(
        "Exclusão parcial — " +
          falhas.join(" | ") +
          ". Tente 'Excluir' de novo em alguns segundos (o backend pode estar acordando).",
        "danger"
      )
      this.fetchLista()
    }
  }

  notify = (message, type = "info") => {
    this.setState({
      alert: (
        <ReactBSAlert
          {...(type === "success" ? { success: true } : type === "danger" ? { danger: true } : { warning: true })}
          style={{ display: "block", marginTop: "-100px" }}
          title=""
          onConfirm={() => this.setState({ alert: null })}
          onCancel={() => this.setState({ alert: null })}
          confirmBtnBsStyle={type === "danger" ? "danger" : type === "success" ? "success" : "warning"}
          confirmBtnText="Ok"
          btnSize=""
        >
          {message}
        </ReactBSAlert>
      ),
    })
  }

  renderPaginacao() {
    const { page, total, pageSize } = this.state
    const nPages = Math.max(1, Math.ceil(total / pageSize))
    if (nPages <= 1) return null
    const paginas = []
    for (let p = 1; p <= nPages; p++) {
      if (p === 1 || p === nPages || Math.abs(p - page) <= 2) paginas.push(p)
      else if (paginas[paginas.length - 1] !== "…") paginas.push("…")
    }
    return (
      <Pagination className="pagination justify-content-end mt-3" listClassName="justify-content-end">
        <PaginationItem disabled={page <= 1}>
          <PaginationLink onClick={() => this.goToPage(page - 1)}>‹</PaginationLink>
        </PaginationItem>
        {paginas.map((p, i) =>
          p === "…" ? (
            <PaginationItem disabled key={`e${i}`}>
              <PaginationLink>…</PaginationLink>
            </PaginationItem>
          ) : (
            <PaginationItem active={p === page} key={p}>
              <PaginationLink onClick={() => this.goToPage(p)}>{p}</PaginationLink>
            </PaginationItem>
          )
        )}
        <PaginationItem disabled={page >= nPages}>
          <PaginationLink onClick={() => this.goToPage(page + 1)}>›</PaginationLink>
        </PaginationItem>
      </Pagination>
    )
  }

  renderDetalhe() {
    const it = this.state.detalhe
    if (!it) return null
    //====== WR data 16/09/2026 — pedido do usuário: o label "Código do fornecedor (cProd)"
    // (mais longo que os outros) estava sobrepondo o valor — a célula do label não tinha
    // whiteSpace:"normal" explícito (só o valor tinha), então em alguns rótulos o texto não
    // quebrava linha dentro do width:170 fixo.
    const linha = (k, v) => (
      <tr>
        <td
          className="text-muted align-top"
          style={{ width: 170, wordBreak: "break-word", whiteSpace: "normal" }}
        >
          {k}
        </td>
        <td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{v || "—"}</td>
      </tr>
    )
    return (
      <Modal className="modal-dialog-centered" size="lg" isOpen={!!it}>
        <div className="modal-header">
          <h5 className="modal-title" style={{ wordBreak: "break-word" }}>
            {it.itemName || it.itemCode}
          </h5>
          <button className="close" onClick={() => this.setState({ detalhe: null })}>
            <span>×</span>
          </button>
        </div>
        <div className="modal-body" style={{ overflowWrap: "anywhere" }}>
          <Table size="sm" borderless style={{ tableLayout: "fixed", width: "100%" }}>
            <tbody>
              {linha("ItemCode", it.itemCode)}
              {linha("ItemName", it.itemName)}
              {linha("Grupo (code)", it.itemsGroupCode)}
              {linha("Unidade (InventoryUOM)", it.inventoryUOM)}
              {linha(
                "Estoque / Venda / Compra",
                `${simNao(it.inventoryItem)} / ${simNao(it.salesItem)} / ${simNao(it.purchaseItem)}`
              )}
              {linha("Código de barras (EAN)", it.cEAN)}
              {linha("NCM", it.ncm)}
              {linha("CFOP", it.cfop)}
              {linha("Tipo de material", MATERIAL_TYPE_LABELS[it.materialType] || "—")}
              {linha("CEST", it.cestCode)}
              {linha("Origem (ICMS)", it.origemIcms)}
              {linha("Administrar por", ADMINISTRAR_POR_LABELS[it.administrarPor] || "Nenhum")}
              {/* WTLiable não é persistido à parte — é sempre derivado do Tipo de material no
              momento da gravação (mt_Service -> Sim, qualquer outro -> Não). */}
              {linha("Sujeito a retenção de imposto", it.materialType === "mt_Service" ? "Sim" : "Não")}
              {linha("Código do fornecedor (cProd)", it.cProd)}
              {linha("Quantidade (última nota)", formatQuantidade(it.quantidadeComercial))}
              {linha("Valor unitário (última nota)", formatValorItem(it.valorUnitarioComercial))}
              {linha("Situação", it.valid === "tYES" ? "Ativo" : "Inativo")}
              {linha("Status", it.status === "gravado_sap" ? "Gravado no SAP" : "Simulado (não gravado)")}
              {linha("Nota de origem", [it.origemNumeroNf, it.origemArquivoNome].filter(Boolean).join(" — "))}
              {linha("Preparado por", it.preparadoPor)}
              {linha("Preparado em", formatarData(it.preparadoEm))}
              {linha("Gravado em", formatarData(it.gravadoEm))}
            </tbody>
          </Table>
        </div>
        <div className="modal-footer">
          <Button color="danger" disabled={this.state.excluindoId === it._id} onClick={() => this.handleExcluir(it)}>
            {this.state.excluindoId === it._id ? "Excluindo..." : "Excluir"}
          </Button>
          <Button color="secondary" onClick={() => this.setState({ detalhe: null })}>
            Fechar
          </Button>
        </div>
      </Modal>
    )
  }

  render() {
    const { loading, project, alert, itens, listLoading, listError, termo, excluindoId, exportando } =
      this.state

    return (
      <>
        {alert}
        {this.renderDetalhe()}
        <SimpleHeader
          name="Itens Importados"
          items={[
            { level: "nav", name: project ? project.name : "Projeto" },
            { level: "nav", name: "Itens Importados" },
          ]}
        />
        <Container className="mt--6" fluid>
          <Row>
            <Col xl="12">
              {loading || !project ? (
                <Loading modalOpened={loading} />
              ) : (
                <Card>
                  <CardHeader className="d-flex align-items-start justify-content-between">
                    <div>
                      <h5 className="h3 mb-0">Itens Importados</h5>
                      <Input
                        type="text"
                        bsSize="sm"
                        className="mt-2"
                        style={{ maxWidth: 420 }}
                        placeholder="Buscar (ItemCode, descrição, EAN, código do fornecedor)"
                        value={termo}
                        onChange={this.onTermoChange}
                      />
                    </div>
                    {/*====== WR data 16/09/2026 — pedido do usuário: exportar Excel também nesta
                    tela de consulta (busca todas as páginas que batem com o filtro, não só a
                    visível). */}
                    <Button color="secondary" size="sm" onClick={this.handleExportarExcel} disabled={exportando}>
                      {exportando ? "Exportando..." : "Gerar Excel"}
                    </Button>
                  </CardHeader>
                  <CardBody>
                    {listError && <div className="alert alert-danger">{listError}</div>}
                    {listLoading ? (
                      <p className="text-muted small">Carregando...</p>
                    ) : itens.length === 0 ? (
                      <p className="text-muted small">
                        {termo
                          ? "Nenhum item encontrado para essa busca."
                          : 'Nenhum item importado ainda. Prepare e grave itens na aba "Revisão e Gravação SAP" do modo Item, no SmartFlow Importer.'}
                      </p>
                    ) : (
                      <>
                        <div className="table-responsive">
                          <Table className="align-items-center table-flush" responsive hover>
                            <thead className="thead-light">
                              <tr>
                                <th>ItemCode</th>
                                <th>ItemName</th>
                                <th>Grupo</th>
                                <th>Unidade</th>
                                <th>EAN</th>
                                <th>Situação</th>
                                <th>Status</th>
                                <th>Origem</th>
                                <th>Preparado em</th>
                                <th />
                              </tr>
                            </thead>
                            <tbody>
                              {itens.map((it) => (
                                <tr
                                  key={it._id}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => this.setState({ detalhe: it })}
                                >
                                  <td>{it.itemCode}</td>
                                  <td>{it.itemName || "—"}</td>
                                  <td>{it.itemsGroupCode ?? "—"}</td>
                                  <td>{it.inventoryUOM || "—"}</td>
                                  <td className="small">{it.cEAN || "—"}</td>
                                  <td>
                                    <Badge color={it.valid === "tYES" ? "success" : "danger"}>
                                      {it.valid === "tYES" ? "Ativo" : "Inativo"}
                                    </Badge>
                                  </td>
                                  <td>
                                    <Badge color={it.status === "gravado_sap" ? "success" : "warning"}>
                                      {it.status === "gravado_sap" ? "Gravado no SAP" : "Simulado"}
                                    </Badge>
                                  </td>
                                  <td className="small">
                                    {[it.origemNumeroNf, it.origemArquivoNome].filter(Boolean).join(" — ") || "—"}
                                  </td>
                                  <td className="small">{formatarData(it.preparadoEm)}</td>
                                  <td onClick={(e) => e.stopPropagation()}>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      disabled={excluindoId === it._id}
                                      onClick={() => this.handleExcluir(it)}
                                    >
                                      {excluindoId === it._id ? "..." : "Excluir"}
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                        {this.renderPaginacao()}
                      </>
                    )}
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}

export default SmartFlowItemsImportados
